<div class="plants-production">
  <h5>{{'order.production'|translate}} {{'ui.per'|translate|lowercase}} {{'company.plant'|translate|lowercase}}</h5>
  <div class="list">
    <div *ngFor="let plant of plants" class="me-2">
      <div class="clearfix">
        <div class="float-left"><b>{{plant.name}}</b></div>
        <div class="float-right">
          <b>{{plant.summary.deliveredAmount | float:2}}</b> / <b>{{plant.summary.plannedAmount | float:2}}</b> m<sup>3</sup>
        </div>
      </div>
      <div>
        <ngb-progressbar class="mb-3" textType="white" [value]="plant.summary.progressPercentage" [showValue]="true"></ngb-progressbar>
      </div>
    </div>
  </div>
</div>
